<template>
    <v-row dense>
        <v-col cols="12" sm="6" md="6">
            <v-text-field
                :model-value="modelValue.driver_name"
                :label="$t('reservation.driverName')"
                variant="outlined"
                :density="density"
                hide-details="auto"
                :rules="required ? [requiredRule] : []"
                @update:model-value="updateField('driver_name', $event)"
            />
        </v-col>
        <v-col cols="12" sm="6" md="6">
            <v-text-field
                :model-value="modelValue.driver_surname"
                :label="$t('reservation.driverSurname')"
                variant="outlined"
                :density="density"
                hide-details="auto"
                :rules="required ? [requiredRule] : []"
                @update:model-value="updateField('driver_surname', $event)"
            />
        </v-col>
    </v-row>
    <v-row dense>
        <v-col cols="12" sm="6" md="6">
            <v-text-field
                :model-value="modelValue.car_number"
                :label="$t('reservation.carNumber')"
                variant="outlined"
                :density="density"
                hide-details="auto"
                :rules="required ? [requiredRule] : []"
                @update:model-value="updateField('car_number', $event)"
            />
        </v-col>
        <v-col cols="12" sm="6" md="6">
            <v-text-field
                :model-value="modelValue.customs"
                :label="$t('reservation.customs')"
                variant="outlined"
                :density="density"
                hide-details="auto"
                @update:model-value="updateField('customs', $event)"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ReservationDriverFields",
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        density: {
            type: String,
            default: "comfortable",
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
    computed: {
        requiredRule() {
            return (inputValue) =>
                !!(inputValue != null && String(inputValue).trim()) || this.$t("validation.required");
        },
    },
    methods: {
        updateField(fieldName, fieldValue) {
            this.$emit("update:modelValue", { ...this.modelValue, [fieldName]: fieldValue });
        },
    },
};
</script>
